import React, { useEffect, useState } from "react";
import { makeRequest } from "../../../api";
import CircularProgressLoader from "../../CircularProgressLoader";
import { handleOverlappingTigersExport } from "../../../utils/mapUtils";

const OverlappingTigers = ({ selectedYear, selectedGender }) => {
  const [loading, setLoading] = useState(false);
  const [overlapData, setOverlapData] = useState({});

  useEffect(() => {
    fetchOverlappingTigersData();
  }, [selectedYear, selectedGender]);

  const fetchOverlappingTigersData = async () => {
    setLoading(true);
    let token = "";

    try {
      if (localStorage.token) {
        token = localStorage.token;
      }
      const queryParams = [`year=${selectedYear}`];

      if (selectedGender === "male-against-female") {
        queryParams.push(`against_male=true`);
      } else if (selectedGender !== "all") {
        queryParams.push(`gender=${selectedGender}`);
      }

      const result = await makeRequest(
        "get",
        `api/v1/identification/tiger_overlapping_list/?${queryParams.join("&")}`
      );

      if (result && result.data) {
        console.log(result.data);
        setOverlapData(result.data.data || {});
      } else {
        console.warn("No data available");
        setOverlapData({});
      }

      setLoading(false);
    } catch (error) {
      console.error("Error fetching polygon data:", error);
      setOverlapData({});
      setLoading(false);
    }
  };

  const getGenderLabel = (gender) => {
    switch (gender) {
      case "male":
        return "Male";
      case "female":
        return "Female";
      case "male-against-female":
        return "Females to Male Dist.";
      case "all":
      default:
        return "All";
    }
  };

  const isDataEmpty = !overlapData || Object.keys(overlapData).length === 0;

  return (
    <div>
      {loading ? (
        <div style={{ marginTop: "2vh" }} className="Card loading-container">
          <div className="loading-content">
            <CircularProgressLoader className="loading-spinner" size={48} />
            <p>Loading tiger territory data...</p>
          </div>
        </div>
      ) : (
        <div className="Card tiger-overlap-wrapper">
          <div className="tiger-overlap-header">
            <h4 className="main-title">Tiger Territory Overlap Analysis</h4>
            <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
              <span>{getGenderLabel(selectedGender)}</span>
              {!isDataEmpty && (
                <div
                  className="Setting_Add_Button"
                  onClick={() =>
                    handleOverlappingTigersExport(
                      selectedYear,
                      selectedGender,
                      getGenderLabel,
                      overlapData
                    )
                  }
                >
                  <span> Export Data</span>
                </div>
              )}
            </div>
          </div>

          {isDataEmpty ? (
            <div className="empty-data-container">
              <div className="empty-data-content">
                <h3>No Data Available</h3>
                <p>
                  No tiger territory overlap data found for {selectedGender}{" "}
                  tigers in {selectedYear}.
                </p>
              </div>
            </div>
          ) : (
            <>
              <div className="table-headers">
                <div className="header-main-tiger">Main Tiger</div>
                <div className="header-overlaps">Territory Overlaps</div>
              </div>

              <div className="tiger-overlap-container">
                {Object.entries(overlapData).map(([mainTiger, overlaps]) => (
                  <div key={mainTiger} className="tiger-row">
                    <div className="tiger-header">
                      <div className="tiger-name">{mainTiger}</div>
                      <div className="overlap-count">
                        {overlaps.length} overlaps
                      </div>
                    </div>
                    <div className="overlaps-container">
                      {overlaps.map((overlap, index) => (
                        <div key={index} className="overlap-item">
                          <div className="overlap-tiger">{overlap.tiger}</div>
                          <div className="overlap-details">
                            <span className="area">
                              {overlap.area_m2.toLocaleString()} m²
                            </span>
                            <span
                              className={`percentage ${
                                overlap.percent <= 50 ? "green" : "red"
                              }`}
                            >
                              {overlap.percent.toFixed(2)}%
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default OverlappingTigers;
